import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers';

interface IProps {
  label: string;
  name: string;
  disabled?: boolean;
  value?: Date | null;
  onChange: (date: Date) => void;
}
export default function ViewsDatePicker(props: IProps) {
  const { value, label, disabled, onChange } = props;

  const handleChange = (date: Date | null) => {
    if (date) {
      onChange(date);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        views={['year', 'month']}
        label={label}
        disabled={disabled}
        minDate={new Date('2021-01-01')}
        maxDate={new Date()}
        value={value}
        onChange={handleChange}
        renderInput={(params: any) => <TextField {...params} helperText={null} />}
      />
    </LocalizationProvider>
  );
}
